import React, { useState } from "react"
import PropTypes from "prop-types"
import { Link } from "react-router-dom"
import {
  Row,
  Col,
  BreadcrumbItem,
} from "reactstrap"

const Breadcrumb = props => {
  return (
    <Row className="align-items-center">
      <Col sm={6}>
        <div className="page-title-box">
          <ol className="breadcrumb mb-0">
            <BreadcrumbItem>
              <Link to="/dashboard">{props.title}</Link>
            </BreadcrumbItem>
            <BreadcrumbItem active>{props.breadcrumbItem}</BreadcrumbItem>
          </ol>
        </div>
      </Col>
    </Row>
  )
}

Breadcrumb.propTypes = {
  breadcrumbItem: PropTypes.string,
  title: PropTypes.string,
}

export default Breadcrumb
